import React, { type ReactNode } from 'react';

import { BackButton, HeaderBorder, HeaderWrapper, Heading, InnerContent, Outer, Wrapper } from './styles';

interface Props {
    handleClose(): void;
    children: ReactNode;
    heading: string;
    isFaded: boolean;
    contentHeight?: number;
    headingSize: 'large' | 'small';
}

const Modal = ({ handleClose, contentHeight, heading, isFaded, children }: Props) => {
    return (
        <Outer isFaded={isFaded} contentHeight={contentHeight}>
            <Wrapper contentHeight={contentHeight}>
                <HeaderWrapper>
                    <Heading>{heading}</Heading>
                    <BackButton color="secondary" onClick={handleClose} />
                </HeaderWrapper>
                <HeaderBorder />
                <InnerContent>{children}</InnerContent>
            </Wrapper>
        </Outer>
    );
};

export default Modal;
